module.exports = __webpack_public_path__ + "img/aboutus_develop.7d196c31.png";